import executiveProfile from '../../widgets/general/executive-profile'
import executiveArticles from '../../widgets/general/executive-articles'

const createExecutiveLayoutWidgets = () => [
  executiveProfile(),
  executiveArticles()
]

export default createExecutiveLayoutWidgets
